export default __webpack_public_path__ + "static/media/search-icon-disable.c4e7c638.svg";